import { DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI } from '../../../types/default-cloud-graph-dashboard-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI } from '../../../types/default-cloud-graph-data-table-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { DatabricksIcon, DatabricksSearchResultIcon } from './icon';

export const databricksConfig: ThirdPartyConfig = {
	displayName: 'Databricks',
	id: 'databricks',
	resourceType: ProductResourceTypes3P.Databricks,
	icon: get3PLogo(DatabricksIcon, 'Databricks', 'medium'),
	searchResultIcon: get3PLogo(DatabricksSearchResultIcon, 'Databricks', 'large'),
	integrationAri: 'ari:cloud:platform::integration/databricks',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Dashboard,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.DataTable,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
